import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../utils/adminApi";

import InnerBanner from "../components/InnerBanner";
import serviceBg from "../assets/FFO+.jpeg";

import "./Services.css";

const API = API_BASE_URL;
const MAX_SERVICE_NAME_CHARS = 32;
const MAX_SERVICE_SUBTITLE_CHARS = 90;

const Services = () => {

const navigate = useNavigate();
const [services,setServices] = useState([]);
const [brokenImages, setBrokenImages] = useState({});

const getServiceImageUrl = (imagePath) => {

  if (!imagePath || typeof imagePath !== "string") return "";

  const normalizedPath = imagePath.replace(/\\/g, "/").trim();

  if (/^https?:\/\//i.test(normalizedPath)) return normalizedPath;

  return `${API}/${normalizedPath.replace(/^\/+/, "")}`;

};
useEffect(()=>{

fetchServices();

},[]);

const fetchServices = async ()=>{

try{

  const res = await axios.get(`${API}/api/services`);

  setServices(Array.isArray(res.data) ? res.data : []);
  setBrokenImages({});

}catch(err){

  console.error("Service fetch error:",err);

}

};

const handleBookClick = (service)=>{

sessionStorage.setItem("selectedService",service.name);

navigate("/login");

};

const clampText = (value, maxChars) => {

  if (!value || typeof value !== "string") return "";

  const text = value.trim().replace(/\s+/g, " ");

  if (text.length <= maxChars) return text;

  return `${text.slice(0, maxChars).trimEnd()}...`;

};

return(

<>
<br/>
<br/>
  <InnerBanner title="Our Services" bgImage={serviceBg} />

  <section className="services-section">

    <div className="services-header">

      <motion.h2
        className="section-title"
        initial={{opacity:0,y:30}}
        whileInView={{opacity:1,y:0}}
        transition={{duration:0.6}}
        viewport={{once:true}}
      >
        Select <span className="blue-glow">Service</span>
      </motion.h2>

      <motion.p
        initial={{opacity:0}}
        whileInView={{opacity:1}}
        transition={{delay:0.2}}
        viewport={{once:true}}
      >
            Expert phone repair services you can trust.
      </motion.p>

    </div>

    <div className="services-grid">

      {services.map((service)=>(

        <motion.div
          key={service._id}
          className="service-card"
          whileHover={{scale:1.05}}
          initial={{opacity:0,scale:0.9}}
          whileInView={{opacity:1,scale:1}}
          transition={{type:"spring",stiffness:200}}
          viewport={{once:true}}
        >

          <div className="card-inner">

            {/* IMAGE */}

            <div className="icon-box">
              {getServiceImageUrl(service.image) && !brokenImages[service._id] ? (
                <img
                  src={getServiceImageUrl(service.image)}
                  alt={service.name}
                  className="service-image"
                  onError={() =>
                    setBrokenImages((prev) => ({ ...prev, [service._id]: true }))
                  }
                />
              ) : (
                <span className="service-image-fallback">No Image</span>
              )}
            </div>

            <h3>{clampText(service.name, MAX_SERVICE_NAME_CHARS)}</h3>

            <p>
              {clampText(
                service.subtitle || "Professional repair service available",
                MAX_SERVICE_SUBTITLE_CHARS
              )}
            </p>

            <motion.button
              className="repair-btn"
              whileHover={{scale:1.1}}
              whileTap={{scale:0.95}}
              onClick={()=>handleBookClick(service)}
            >
              Book Repair
            </motion.button>

          </div>

          <div className="card-glow"></div>

        </motion.div>

      ))}

    </div>

  </section>

</>

);

};

export default Services;
